module.exports = __webpack_public_path__ + "static/media/2.92714233.jpg";